export const APP_CONFIGS = `
# API Configs
API_REQUEST_CHANNEL_KEY=channel
API_REQUEST_TOKEN_KEY=token
API_BASE_URL=https://3f80jtc3lk.execute-api.ap-south-1.amazonaws.com/api
API_METHOD_GET=GET
API_METHOD_POST=POST
API_METHOD_PUT=PUT
API_METHOD_DELETE=DELETE
# Security Configs
CRYPT_KEY=12345678901234567890123456789012
# Payload Configs
ACCESS_KEY=Access10003
SUBSIDIARY_CODE=10001
API_TOKEN=BD2C4EAEB1A4CBDC691343956B90251AEB783F7669AD47B790EF2E4F471E2FF4
# Device Configs
DEVICE_FINGERPRINT=deviceFingerprint
`;
